/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Col_SourceInputs */

const vi_sl_detail_col_source = /** @type {(inputs: Sl_Detail_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô chè mua nguồn`)
};

/**

* @param {Sl_Detail_Col_SourceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_col_source = /** @type {((inputs?: Sl_Detail_Col_SourceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Col_SourceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_col_source(inputs)
});